var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"mb-2",on:{"click":_vm.goBack}},[_c('b-icon-chevron-left'),_vm._v(" Назад ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }